// setup wechat jssdk

import wxjs from '../util/wechat'

// // setup qiyukefu component.
// import './kf.js'

// setup growingio analytics
const env = process.env || 'development'

if (process.env.NODE_ENV === 'preview') {
  require('./analytics/sentry')
} else if(process.env.NODE_ENV === 'development') {
  require('./analytics/tongji_dev')
} else {
  // setup growingio analytics
  require('./analytics/growingio')
  // setup baidutongji analytics
  require('./analytics/tongji_prod')
}

wxjs()
